import { render, staticRenderFns } from "./GerarPagamentosModal.vue?vue&type=template&id=33a70db6&scoped=true"
import script from "./GerarPagamentosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GerarPagamentosModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GerarPagamentosModal.vue?vue&type=style&index=0&id=33a70db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a70db6",
  null
  
)

export default component.exports